<template>
  <div class="buynow">
    <section class="section1 container">
      <img class="wave-top" src="@/assets/img/wave_top_page.png" />
      <img class="wave-top-mobile" src="@/assets/img/wave_top_mobile.png" />
      <!-- <h2 class="section-title">Upmood Bracelet</h2> -->
      <div class="wrapper">
        <div class="upmood-band-small-wrapper">
          <img
            class="upmood-band-small"
            src="@/assets/img/upmood_band_real_small1.png"
            @click="upmoodReal = true"
          />
          <img
            class="upmood-band-small"
            src="@/assets/img/upmood_band_real_small2.png"
            @click="upmoodReal = false"
          />
        </div>

        <div class="upmood-band-real-wrapper">
          <img
            class="upmood-band-real"
            src="@/assets/img/upmood_band_real1.png"
            v-show="upmoodReal"
          />
          <img
            class="upmood-band-real"
            src="@/assets/img/upmood_band_real2.png"
            v-show="!upmoodReal"
          />
        </div>
        <div class="available-now">
          <h3>Available Now!</h3>
          <h1>99.99 USD</h1>
          <!-- <p>First real time wearable emotion tracking app.</p> -->
          <ul>
            <li>First live emotion detection wearable and app.</li>
            <li>
              Collects bio data from the user and results in 11 different
              emotional states(calm, pleasant, unpleasant, happy, sad,
              excitement, anxious, confused, challenged, tense and zen), stress
              level and BPM, every 1.5 to 3mins.
            </li>
            <li>Gives user insight on their emotional patterns and trends.</li>
            <li>Enhance one’s emotional management.</li>
          </ul>
          <button
            class="button-cyan"
            @click="$router.push({ name: 'order', query: { item: 'band' } })"
          >
            BUY
          </button>
        </div>
      </div>
      <div class="circle-blue animate-growing"></div>
      <div class="circle-light-yellow circle1 animate-shrinking"></div>
      <div class="circle-yellow circle2 animate-shrinking"></div>
    </section>

    <div class="section2 container">
      <h2>What you'll get</h2>
      <div class="wrapper">
        <div class="item">
          <!-- <img src="@/assets/img/upmood_band_real1.png" alt=""> -->
          <div class="item-image-wrapper">
            <div
              class="item-image"
              :style="
                `background-image: url(${require('@/assets/img/upmood_band_real1.png')})`
              "
            ></div>
          </div>
          <span>Upmood Band</span>
        </div>

        <div class="item">
          <!-- <img src="@/assets/img/Charger.png" alt=""> -->
          <div class="item-image-wrapper">
            <div
              class="item-image"
              :style="
                `background-image: url(${require('@/assets/img/Charger.png')})`
              "
            ></div>
          </div>
          <span>Upmood Band Charger</span>
        </div>

        <div class="item">
          <!-- <img src="@/assets/img/strap.png" alt=""> -->
          <div class="item-image-wrapper">
            <div
              class="item-image"
              :style="
                `background-image: url(${require('@/assets/img/strap.png')})`
              "
            ></div>
          </div>
          <span>Upmood Band Strap</span>
        </div>
      </div>
    </div>

    <div class="faq container">
      <h2>Frequently Ask Questions</h2>

      <div class="question-wrapper">
        <div class="header" @click="toggleFAQ(1)">
          <h3>Pricing and Purchasing</h3>
          <img
            src="@/assets/img/ic_arrow_circle.png"
            alt=""
            class="icon-arrow"
            :class="{ active: isFAQ1 }"
          />
        </div>

        <div class="content" :class="{ active: isFAQ1 }">
          <div class="wrapper">
            <h4>
              <span>Q:</span> Can I use the app even if I haven’t purchased the
              band yet?
            </h4>
            <p>
              <span>A:</span> Certain features of the app can be enjoyed even
              without the band such as viewing other people’s emotion and trends
              and reacting to them, but your own cannot be viewed nor can be
              acknowledged.
            </p>

            <h4><span>Q:</span> When will I get my Upmood Wearable?</h4>
            <p>
              <span>A:</span> Production of the first batch of Upmood bands
              (non-trial) warrants us to start shipment by September (given no
              unforeseen production delays).
            </p>

            <h4><span>Q:</span> What comes with my order?</h4>
            <p>
              <span>A:</span> Every purchase of the Upmood band comes with 1
              Upmood Band, 2 Straps (1 black, 1 sea green), 1 Charging Cable,
              and an Instruction Manual.
            </p>

            <h4><span>Q:</span> Does the band come with a warranty?</h4>
            <p>
              <span>A:</span> Warranty Period： 1 Year from purchase Date <br />
              Warranty Supplier Name : TaisonDigital LTD. You will be able to
              claim your warranty online at www.upmood.com<br />
              Service Centre Address : Taison Digital Ltd. Unit 29, 18/F, Block
              B, Wah Lok Ind. Centre, 37－41 Shan Mei Street, Fo Tan, Shatin,
              N.T.<br />
              Service Centre Email : support@upmood.com<br />
              Service Centre Contact : +852 23699788
            </p>

            <h4><span>Q:</span> What countries are you shipping to?</h4>
            <p><span>A:</span> We are available for shipping worldwide.</p>

            <h4><span>Q:</span> What are the shipping costs?</h4>
            <p>
              <span>A:</span> Shipping cost will depend on the quantity of your
              order and your location. To view the cost, simply indicate your
              country upon checkout and it will be shown right away.
            </p>
          </div>
        </div>
      </div>

      <div class="question-wrapper">
        <div class="header" @click="toggleFAQ(2)">
          <h3>Usage and Functionalities</h3>
          <img
            src="@/assets/img/ic_arrow_circle.png"
            alt=""
            class="icon-arrow"
            :class="{ active: isFAQ2 }"
          />
        </div>

        <div class="content" :class="{ active: isFAQ2 }">
          <div class="wrapper">
            <h4><span>Q:</span> How does Upmood track emotions?</h4>
            <p>
              <span>A:</span> Upmood collects biodata from your heart rate and
              contractions through a PPG sensor using only one wrist, with an
              unprecedented level of accuracy. The algorithm turns the data from
              your pulse waves into analytics, through Bluetooth connection to
              the app, to let you know of your stress level, heart rate,
              vitality levels, and emotions.
            </p>

            <h4>
              <span>Q:</span> What are the emotions available in the mood feed?
            </h4>
            <p>
              <span>A:</span> 11 current Emotion status are calm, pleasant,
              unpleasant, happy, sad, excitement, anxious, confused, challenged,
              tense and zen.
            </p>

            <h4><span>Q:</span> What sizes and colors are available?</h4>
            <p>
              <span>A:</span> Choose a strap that fits your mood from our
              assortment of lightweight, highly-durable polyester straps that
              come in black and exclusive Upmood colors — sea green.
            </p>

            <h4><span>Q:</span> What is the band's battery life?</h4>
            <p><span>A:</span> Stand by time: 48 hours, always on: 12 hours</p>

            <h4>
              <span>Q:</span> What are the color representations for the stress
              level?
            </h4>
            <p>
              <span>A:</span> Stress level display in Upmood are as follows: RED
              for High/Severe, YELLOW for Normal/Moderate, SEA GREEN for Mild
              and BLUE for Low Stress level.
            </p>

            <h4>
              <span>Q:</span> What are the mood representations for each color?
            </h4>
            <p>
              <span>A:</span> Each Upmood color represents a certain mood.
              ORANGE represents calmness, RED represents sadness and BLUE
              represents happiness.
            </p>

            <h4><span>Q:</span> Will the band work even without the app?</h4>
            <p>
              <span>A:</span> Yes the band will work but without the app, every
              data collected will not be generated and translated into an actual
              emotion.
            </p>

            <h4><span>Q:</span> How can I get in touch with your team?</h4>
            <p>
              <span>A:</span> If you have any questions about the campaign, the
              product, or just a fancy chat with the team, you can reach us over
              at <i>support@upmood.com</i>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!--  -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      isFAQ1: false,
      isFAQ2: false,

      upmoodReal: false
    };
  },

  methods: {
    toggleFAQ(faq) {
      if (faq === 1) {
        this.isFAQ2 = false;
        this.isFAQ1 = !this.isFAQ1;
      } else {
        this.isFAQ1 = false;
        this.isFAQ2 = !this.isFAQ2;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.buynow {
  .section1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    margin-bottom: 100px;
    margin-top: 160px;

    .wave-top {
      position: absolute;
      display: block;
      top: -240px;
      width: 115%;
      right: -325px;

      @include mobile {
        display: none;
      }
    }

    .wave-top-mobile {
      display: none;

      @include mobile {
        position: absolute;
        top: -200px;
        width: 115%;
        height: 100px;
        display: block;
      }
    }

    .wrapper {
      display: flex;
      align-items: flex-end;
      width: 100%;

      @include mobile {
        flex-direction: column;
      }
    }

    .upmood-band-real-wrapper {
      width: 300px;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: +1;

      @include mobile {
        width: 100%;
        margin-top: 50px;
        margin-bottom: 30px;
        order: 1;
        margin-top: 50px;
      }

      .upmood-band-real {
        height: 400px;

        @include mobile {
          height: 250px;
        }
      }
    }

    .upmood-band-small-wrapper {
      height: 100%;
      width: 95px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      margin-right: 50px;
      // position: absolute;
      // bottom: 0;
      // left: 100px;
      z-index: +1;

      @include mobile {
        align-self: flex-start;
        flex-direction: row;
        justify-content: center;
        height: 60px;
        width: 100%;
        order: 2;
        margin-bottom: 20px;
      }

      .upmood-band-small {
        width: 95px;
        height: 95px;
        background-color: #fff;
        cursor: pointer;

        &:first-child {
          margin-bottom: 20px;
        }

        @include mobile {
          width: 60px;
          height: 60px;

          &:first-child {
            margin-bottom: 0;
            margin-right: 20px;
          }
        }
      }
    }

    .available-now {
      flex: 1 1 auto;
      // height: 240px;
      margin-left: 50px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
      padding: 30px;
      align-self: center;
      z-index: 2;
      background-color: #fff;

      @include mobile {
        margin: 0;
        order: 3;
        height: auto;
        text-align: center;
      }

      h3 {
        color: #d65c30;
        font-size: 24px;
        margin-bottom: 20px;
      }

      h1 {
        color: #ef7f57;
        font-size: 26px;
        margin-bottom: 20px;
      }

      ul {
        margin-bottom: 20px;
        margin-left: 20px;
        text-align: left;

        li {
          color: #acacac;
          font-size: 14px;
          line-height: 18px;
          margin-bottom: 5px;
        }
      }

      button {
        width: 100px;
      }
    }

    .circle-blue {
      height: 183px;
      width: 183px;
      position: absolute;
      top: 0;
      left: -100px;

      @include mobile {
        height: 50px;
        width: 50px;
        top: -80px;
        left: -20px;
      }
    }

    .circle1 {
      position: absolute;
      height: 118px;
      width: 118px;
      top: -165px;
      left: 225px;

      @include mobile {
        height: 50px;
        width: 50px;
        top: -115px;
        left: 110px;
      }
    }

    .circle2 {
      position: absolute;
      height: 315px;
      width: 315px;
      right: -220px;
      bottom: -100px;

      @include mobile {
        height: 150px;
        width: 150px;
        right: -75px;
        bottom: 0px;
      }
    }
  }

  .section2 {
    margin-bottom: 100px;

    h2 {
      text-align: center;
      color: #14b993;
      margin-bottom: 20px;
      font-size: 34px;

      @include mobile {
        font-size: 18px;
      }
    }

    .wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;

      @include mobile {
        flex-direction: column;
      }

      .item {
        display: flex;
        align-items: center;

        @include mobile {
          max-width: 300px;
          width: 100%;
          margin-bottom: 10px;
          flex-direction: column;
        }

        .item-image-wrapper {
          width: 100px;
          height: 100px;
          padding: 5px;
          border: 1px solid #91aaaa;
          border-radius: 50%;
          background-color: #fff;
          margin-right: 20px;
          flex-shrink: 0;

          @include mobile {
            margin-right: 0;
            margin-bottom: 10px;
          }

          .item-image {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            background-color: #fff;
          }
        }

        span {
          font-size: 18px;
          color: #91aaaa;

          @include mobile {
            font-size: 14px;
          }
        }
      }
    }
  }

  .faq {
    margin-bottom: 200px;

    h2 {
      text-align: center;
      color: #14b993;
      margin-bottom: 20px;
      font-size: 34px;

      @include mobile {
        font-size: 18px;
      }
    }

    .question-wrapper {
      margin-bottom: 20px;
      box-shadow: 0 5px 10px rgba(231, 231, 231, 0.5);

      .header {
        padding: 15px;
        border: 1px solid $color9;
        position: relative;
        display: flex;
        align-items: center;
        cursor: pointer;

        h3 {
          color: #91aaaa;
          flex: 1 1 auto;
          font-weight: 400;
          font-size: 18px;

          @include mobile {
            font-size: 14px;
          }
        }

        .icon-arrow {
          width: 20px;
          height: 20px;

          &.active {
            transform: rotateZ(180deg);
          }
        }
      }

      .content {
        overflow: hidden;
        max-height: 0;
        transition: 0.5s ease;
        border: 1px solid $color9;
        background-color: #fff;

        .wrapper {
          padding: 10px 0;
        }

        &.active {
          max-height: unset;
        }

        h4 {
          font-size: 14px;
          padding: 10px 15px;
          color: #91aaaa;

          span {
            color: #14b993;
            font-weight: 500;
          }
        }

        p {
          color: #91aaaa;
          font-size: 14px;
          padding: 10px 15px;
          line-height: 18px;

          span {
            color: #14b993;
            font-weight: 500;
          }

          a {
            color: #91aaaa;
          }
        }
      }
    }
  }
}
</style>
